import { Logo } from './Logo';

export const Header = () => {
    return (
        <header className="addiko-header">           
            <Logo />
        </header>
    );
}